import React, { PureComponent } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

import CarsListReports from "../reports/carsListReports";

class ReportsListWrapper extends PureComponent {
  handleScrollTo(top) {
    const { scrollbars } = this.refs;

    if (scrollbars) scrollbars.scrollTop(top);
  }

  render() {
    return (
      <Scrollbars style={{ height: "100%" }} autoHide={true} ref="scrollbars">
        <CarsListReports handleScrollTo={this.handleScrollTo.bind(this)} />
      </Scrollbars>
    );
  }
}

export default ReportsListWrapper;
